import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import {
  CloseSideBar,
  Home,
  OpenSideBar,
  InManagement,
  DrobdownArrow,
  SideMenuPin,
  DocTemplate,
} from "../../HemeIconLibrary";
import { setSideBar } from "../../Store/reducers/uiSettings";

const Sidebar = ({ setShowDashboard, isCollapse, setisCollapse }) => {
  // const { permissions } = useSelector((state) => state.common);
  const { uisettings, orders } = useSelector((state) => state);

  const [dropdown, setDropdown] = useState(false);

  const [sidebarData, setSidebarData] = useState([]);
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    const sidebarDataMenu = [
      {
        name: "Orders",
        path: "/",
        icon: <Home />,
        show: orders.kitsAccess === true, //permissions?.["Kit Order Process"]?.read ? true : false,
        cta: () => setShowDashboard(true),
      },
      {
        name: "Site Documents",
        path: "/documents",
        icon: <InManagement />,
        show: orders.kitsAccess === true,//permissions?.["Inventory Management"]?.read ? true : false,
      },
      {
        name: "Reports",
        path: "/reports",
        icon: <DocTemplate />, 
        show: orders.reportsAccess === true,//permissions?.["Inventory Management"]?.read ? true : false,
      },
    ];
    setSidebarData(sidebarDataMenu);
  }, [orders.kitsAccess, orders.reportsAccess]);
  // useEffect(()=>{
  //   setSidebarData(sidebarDataMenu)
  // },[JSON.stringify(pemrissions)])
  return (
    <div className="fixed z-[3] top-0 left-0">
      <div
        className={`h-[calc(100vh-0px)] bg-white transition-all duration-300 ${
          isCollapse ? "w-[216px] absolute hema-sidebar" : "w-[70px] relative"
        }`}>
        <ul className="pt-[97px] pb-[28px] pl-0 flex flex-col gap-[23px] h-full relative">
          {/* Pin icon */}
          <div
            onClick={() => {
              if (localStorage.getItem("sidebarOpen") === "true") {
                localStorage.setItem("sidebarOpen", "false");
                setisCollapse(!isCollapse);
                dispatch(setSideBar(!isCollapse));
              } else {
                localStorage.setItem("sidebarOpen", "true");
                setisCollapse(!isCollapse);
                dispatch(setSideBar(!isCollapse));
              }
            }}
            className="absolute top-[76px] right-[4px] z-[2] cursor-pointer">
            <SideMenuPin />
          </div>
          {sidebarData?.map((item, index) => (
            <>
              {item.show && (
                <li
                  key={index}
                  className="relative w-full"
                  onMouseLeave={() => setDropdown()}>
                  <NavLink
                    key={index}
                    exact
                    activeClassName="active"
                    to={item.path}
                    className={
                      location.pathname?.toLocaleLowerCase()?.trim() ===
                      item.path
                        ? isCollapse
                          ? " nav-link is-collapse-active mx-0 hover:mx-0"
                          : "nav-link is-active mx-[11px] center"
                        : isCollapse
                        ? "nav-link mx-0"
                        : "nav-link mx-[11px] center"
                    }
                    onClick={() => {
                      setisCollapse(false);
                      localStorage.removeItem("activeLocation");
                      if (item?.cta) {
                        item?.cta();
                      }
                      setisCollapse(!!uisettings.sidebarOpen);
                    }}
                    onMouseEnter={() => setDropdown(index)}>
                    <div key={index} className="flex items-center">
                      {item.icon}
                      {isCollapse && (
                        <span
                          key={index}
                          className={`${
                            location.pathname?.toLocaleLowerCase()?.trim() ===
                            item.path
                              ? "is-collapse-active"
                              : "text-[#2D3B48]"
                          } font-medium text-[12px] ml-[12px] sidebar-text`}>
                          {item.name}
                        </span>
                      )}
                    </div>
                    {isCollapse && item.dropdownItems ? (
                      dropdown === index ? (
                        <DrobdownArrow key={index} />
                      ) : (
                        <div key={index} className="rotate-90">
                          <DrobdownArrow key={index} color="#2D3B48" />
                        </div>
                      )
                    ) : (
                      ""
                    )}
                  </NavLink>
                  {item.dropdownItems && (
                    <div
                      key={index}
                      className={` min-w-[241px] h-auto absolute rounded-[10px]  top-0  pl-[24px] sideBar-animation
                      z-[-1]
                       ${
                         dropdown === index ? "right-[-230px]" : "right-[215px]"
                       }`}>
                      <div
                        key={index}
                        className={`w-full rounded-[10px] bg-white   sidebar-dropdown `}
                        onMouseLeave={() => setDropdown()}>
                        {item.dropdownItems.map((items, i) => {
                          return (
                            items.show && (
                              <NavLink
                                key={i}
                                onClick={() => {
                                  setisCollapse(false);
                                  localStorage.removeItem("activeLocation");
                                  setisCollapse(!!uisettings.sidebarOpen);
                                }}
                                to={items.path}
                                className="nav-link sidebar-drop-text">
                                <div key={i} className="flex items-center">
                                  <div key={i} className="w-[25px]">
                                    {items.icon}
                                  </div>
                                  <span
                                    key={i}
                                    className="font-medium text-[12px] ml-[12px] text-[#2D3B48]">
                                    {items.name}
                                  </span>
                                </div>
                              </NavLink>
                            )
                          );
                        })}
                      </div>
                    </div>
                  )}
                </li>
              )}
            </>
          ))}
        </ul>
        <div
          className="absolute bottom-1 right-[-12px] cursor-pointer"
          onClick={() => {
            setisCollapse(!isCollapse);
            if (isCollapse) {
              localStorage.setItem("sidebarOpen", "false");
              dispatch(setSideBar(false));
            }
          }}>
          {isCollapse ? <CloseSideBar /> : <OpenSideBar />}
        </div>
      </div>
    </div>
  );
};
export default Sidebar;
